import { Injectable, OnDestroy, OnInit } from '@angular/core';
import {  BehaviorSubject, Observable, Subject, fromEvent,forkJoin, Subscription  } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpHeadersService } from '../shared-service/http-headers.service';
import { Notifications, Notification, NotificationMap, NotificationList } from '../notification/notification.model';
import { Router } from '@angular/router';
import { FacilityService } from '../services/facility.service';
import { take, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class NotificationService implements OnInit,OnDestroy  {
  private _visibleState: boolean = false;
  private _count: number = 0;
  isVisible$ = new Subject<boolean>();
  private _loading = true;
  public notifications$ = new Subject<NotificationList>();
  // public _countChange = new Subject<number>();
  responseData: Notification[];
  notificationData: NotificationList | {};
  notifyMap = NotificationMap;
  dataList = [];
  currentPage: number = 0;
  pageSize: number = 25;
  private sub = new Subscription(); 
  constructor(
    private http: HttpClient,
    private httpHeaderService: HttpHeadersService,
    private _router: Router,
    private _facService: FacilityService
  ) {
    this.isVisible$.next(this._visibleState);
  }

  ngOnInit(){}
  
  async toggleVisibleState() {
    this.loading = true;
    this._visibleState = !this._visibleState;
    this.isVisible$.next(this._visibleState);
    if (this._visibleState) {
      this.currentPage = 0;
      await this.fetch();
      this.loading = false;
    }
  }

  async fetch() {
    const groupBy = (array: Notification[] | undefined, key: string) => {
      if (array?.length) {
        return array.reduce((objectsByKeyValue: any, obj: Notification) => {
          const value = obj[key];
          objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
          return objectsByKeyValue;
        }, {});
      }
    };

    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const initialNotificationSub = this.http.get(`${environment.gcpServicePath}/notifications?page=${this.currentPage}&size=${this.pageSize}`, {headers,observe: 'response'}).subscribe(
      (res: any) => {
        //TODO: grouping by NotificationType 
        if(res){
          this.responseData = res.body as any;
          let data = [];
          data = this.responseData;
          this.dataList = data as any;
          this.notificationData = groupBy(this.dataList, 'notificationType');
          this.count = res.headers.get('x-total-count');
          this.notifications$.next(this.notificationData);
          this.triggerInfiniteScroll();
        }else{
          this.notifications$.next({});
        }
      },
      (err: any) => {}
    );
    this.sub.add(initialNotificationSub);
  }

  triggerInfiniteScroll(){
    const groupBy = (array: Notification[] | undefined, key: string) => {
      if (array?.length) {
        return array.reduce((objectsByKeyValue: any, obj: Notification) => {
          const value = obj[key];
          objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
          return objectsByKeyValue;
        }, {});
      }
    };
    const content = document.querySelector('.halo__notification');
    const scroll$ = fromEvent(content!, 'scroll').pipe(map(() => { return content!.scrollTop; }));
    this.currentPage = 0;
    if(scroll$){
      const scrollSub = scroll$.subscribe((scrollPos) => {
        let limit = content!.scrollHeight - content!.clientHeight;
        if (Math.round(scrollPos) + 2 >= limit && this.dataList.length<this.count) {
         
          this.loading = true;
          this.currentPage ++;
          if(this.currentPage <= (this.count/this.pageSize)){
            const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
            const subSequenceNotificationSub = this.http.get(`${environment.gcpServicePath}/notifications?page=${this.currentPage}&size=${this.pageSize}`, {headers,observe: 'response'}).subscribe(
              (res:any) => {
                //TODO: grouping by NotificationType
                  
                if(res){
                  this.responseData =  res.body as any;
                  let data = [];
                  data = this.responseData;
                  this.dataList = this.dataList.concat(data as any);
                  this.notificationData = groupBy(this.dataList, 'notificationType');
                  this.count = res.headers.get('x-total-count');
                  this.notifications$.next(this.notificationData);
                  this.loading = false;
                }else{
                  this.notifications$.next({});
                  this.loading = false;
                }
              },
              (err: any) => {}
            );
            this.sub.add(subSequenceNotificationSub);
          }
        }
      });
      this.sub.add(scrollSub);
    }
  }

  get count(): number {
    return this._count;
  }

  set count(value: number) {
    this._count = value;
  }

  get loading(): boolean {
    return this._loading;
  }

  set loading(value: boolean) {
    this._loading = value;
  }

  post(ids: String[], facId: string, type: string) {
    let updatedNotifications: Notification[] = [];
    ids.forEach((id: string) => {

      updatedNotifications = (this.dataList as any).filter((data:any) =>
        data.id === id ? (data.readStatus = 'READ') : (data.readStatus = data.readStatus)
      );
      updatedNotifications.map(val => val.metadata = null);
    });
    let payload = new Notifications(updatedNotifications.filter((notify) => notify.readStatus === 'READ'));

    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const notificationPostSub = this.http.post(`${environment.servicePath}/notifications`, payload, { headers }).subscribe(
      (res: Notifications) => {
        this.count--;
        if (type === 'USER_ADDED') {
          this._facService.selectFacility(facId, true);
        }
        this._router.navigate([this.notifyMap.get(type)?.url]);
        this.toggleVisibleState();
      },
      (err: any) => {}
    );
    this.sub.add(notificationPostSub);
  }

  updateStatus(): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this.http.post(`${environment.gcpServicePath}/notifications/update_status`, {}, {headers});
    return result as Observable<any>;
  }

  ngOnDestroy(){
    this.sub.unsubscribe();
  }
}
